import Vue from "vue";
import VueRouter from "vue-router";
import energy from "@/views/home/energy.vue";
Vue.use(VueRouter);

const routes = [
    
	//首页
    {
        path: "/",
        redirect: 'energy',
        meta:{
             title: '',
             keepAlive:true
        }
    },
    
   // {
   //   path: "/homeIndex",
   //   name: "homeIndex",
   // 	meta:{
   // 		title: '九洲物流业务实况数据大屏',
   // 		keepAlive:true
   // 	},
   //   component: () =>
   //     import("../views/home/index1.vue")
   // },
   
   {
     path: "/energy",
     name: "energy",
   	meta:{
   		title: '九洲物流新能源车辆实况',
   		keepAlive:true
   	},
     component: () =>
       import("../views/home/energy.vue")
   },
   {
     path: "/detail",
     name: "detail",
   	meta:{
   		title: '车辆运输数据',
   		keepAlive:false
   	},
     component: () =>
       import("../views/home/detail.vue")
   },
   
    //登录
    {
      path: "/login",
      name: "login",
    	meta:{
    		title: '登录',
    		keepAlive:false
    	},
      component: () =>
        import("../views/login.vue")
    },
    {
      path: "/modifypassword",
      name: "modifypassword",
    	meta:{
    		title: '修改密码',
    		keepAlive:false
    	},
      component: () =>
        import("../views/modifyword.vue")
    },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
	scrollBehavior (to, from, savedPosition) {
	  return new Promise((resolve, reject) => {
	    setTimeout(() => {
	      resolve({ x: 0, y: 0 })
	    }, 1)
	  })
	},
  routes,
});
export default router;
